$(function() {
  $('.sysName input[type="text"]').attr('placeholder', '例) 黒龍堂　花子');
  $('.sysNameKana input[type="text"]').attr('placeholder', '例) コクリュウドウ　ハナコ');
  $('.sysZipcode input[type="text"]').attr('placeholder', '例) 1050011');
  $('.sysAddress1 input[type="text"]').attr('placeholder', '例) 港区');
  $('.sysAddress2 input[type="text"]').attr('placeholder', '例) 芝公園2-6-15 黒龍芝公園ビル9F');
  $('.sysTel input[type="tel"]').attr('placeholder', '例）0334315877');
  $('.sysMailaddress input[type="email"]').attr('placeholder', '例）example@kokuryudo.co.jp');
  $('.sysBirthday input[name="birth_year"]').attr('placeholder', '例）2000');
  $('.sysBirthday input[name="birth_month"]').attr('placeholder', '例）4');
  $('.sysBirthday input[name="birth_day"]').attr('placeholder', '例）1');
  $('.sysFax').css('display', 'none');

  // フリーフォーム お問い合わせ
  if ($('.form-inquiry').length >= 1) {
    $('.sys1 input[type="text"]').attr('placeholder', '例) 黒龍堂　花子');
    $('.sys2 input[type="text"]').attr('placeholder', '例) コクリュウドウ　ハナコ');
    $('.sys3 input[type="text"]').attr('placeholder', '例）example@kokuryudo.co.jp');
    $('.sys4 input[type="text"]').attr('placeholder', '例）0334315877');
  }

  // フリーフォーム 返品・返金・交換
  if ($('.form-form-cancel').length >= 1) {
    $('.sys4 input[type="text"]').attr('placeholder', '例) 黒龍堂　花子');
    $('.sys5 input[type="text"]').attr('placeholder', '例）example@kokuryudo.co.jp');
    $('.sys6 input[type="text"]').attr('placeholder', '例) 1050011');
    $('.sys8 input[type="text"]').attr('placeholder', '例) 港区');
    $('.sys9 input[type="text"]').attr('placeholder', '例) 芝公園2-6-15 黒龍芝公園ビル9F');
    $('.sys10 input[type="text"]').attr('placeholder', '例）0334315877');
  }
});
